"use client";
import React from "react";
import { Comment, Form, Label, Icon } from "semantic-ui-react";
import { ButtonItem } from "../../components";

const Wcomment = ({
  visibility,
  changeval,
  submit,
  value,
  form,
  buttonName,
  placeholder,
  ...props
}) => {
  return (
    <div>
      {visibility ? (
        <Comment.Group style={{ maxWidth: 600, marginLeft: 30 }}>
          <Comment>
            <Comment.Avatar
              src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/userdefault.jpg`}
            />
            <Comment.Content>
              <Form name={form} onSubmit={submit} reply>
                <Form.TextArea
                  {...props}
                  onChange={(e) => changeval(e)}
                  style={{
                    clear: "none",
                    border: "1px solid rgba(34,36,38,.15)",
                  }}
                  value={value}
                  placeholder={placeholder}
                />
                <Label
                  attached="bottom"
                  style={{
                    backgroundColor: "#F9F9FA",
                    border: "1px solid rgba(34,36,38,.15)",
                  }}
                >
                  <ButtonItem
                    content={buttonName}
                    color="green"
                    floated="right"
                  />
                </Label>
              </Form>
            </Comment.Content>
          </Comment>
        </Comment.Group>
      ) : null}
    </div>
  );
};

export default Wcomment;
